'use client'

import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { Search, Notifications } from '@mui/icons-material'
import Image from 'next/image'
import { IUserParent, IUserProfile } from '@/api';
import { useEffect, useState } from 'react';
import NotConnected from './component/NotConnected';
import WaitingConfirm from './component/WaitingConfirm';
import Connected from './component/Connected';

interface ProfileParentProps {
  initialData?: IUserProfile;
}

export default function ProfileParent({
  initialData,
}: ProfileParentProps) {
  const [connected, setConnected] = useState(false);
  const [waitingConfirm, setWaitingConfirm] = useState(false);
  useEffect(()=>{
    if(initialData){
      console.log("------",initialData)
      if(initialData && initialData.parent && initialData.parent.isConnected){
        setConnected(initialData.parent.isConnected)
      }
      if(initialData && initialData.parent && initialData.parent.waitingConfirm){
        setWaitingConfirm(initialData.parent.waitingConfirm)
      }
    }
  }, [initialData])
  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Your Parent Information</Typography>
      {!connected ? (
        waitingConfirm ? (
          <WaitingConfirm />
        ) : (
          <NotConnected />
        )
      ) : (
        <Connected initialData={initialData?.parent} />
      )}
    </Paper>
  )
}

